import qs from 'query-string'
import { omit } from 'lodash'

const ignored = ['page', 'pageNum', 'srchN', 'searchId', 'pageSize']

export const toQueryString = params => `?${qs.stringify(params, { arrayFormat: 'comma' }).replace(/%2C/g, ',')}`

export const queryName = ({ filters = '', ...params }) => toQueryString(omit({ filters, ...params }, ignored)).slice(1)
